import { render } from "./USBankRecognizeMajorScams.vue?vue&type=template&id=f382d26c&scoped=true"
import script from "./USBankRecognizeMajorScams.vue?vue&type=script&lang=js"
export * from "./USBankRecognizeMajorScams.vue?vue&type=script&lang=js"

import "./USBankRecognizeMajorScams.vue?vue&type=style&index=0&id=f382d26c&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f382d26c"]])

export default __exports__